import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ReferenceData } from '../types/reference-data';

export const ReferenceDataActions = createActionGroup({
  source: 'ReferenceData',
  events: {
    'Load All': emptyProps(),
    'Load All Success': props<{ items: ReferenceData[] }>(),
    'Load All Failure': props<{ error: unknown }>(),
  },
});
